var installedModules = {};
var moduleToHandlerMapping = {
	4197: {
		getter: () => (__webpack_require__.e(250).then(() => (() => (__webpack_require__(5250))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.17.21",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	1085: {
		getter: () => (Promise.all([__webpack_require__.e(157), __webpack_require__.e(167)]).then(() => (() => (__webpack_require__(3167))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.83.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/core",
	},
	5703: {
		getter: () => (Promise.all([__webpack_require__.e(197), __webpack_require__.e(131)]).then(() => (() => (__webpack_require__(4512))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.83.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/config",
	},
	7749: {
		getter: () => (Promise.all([__webpack_require__.e(694), __webpack_require__.e(197), __webpack_require__.e(936)]).then(() => (() => (__webpack_require__(4071))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.83.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/dev-tools-utils",
	},
	9597: {
		getter: () => (__webpack_require__.e(794).then(() => (() => (__webpack_require__(3794))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.13.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "mobx",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"85": [
		1085
	],
	"197": [
		4197
	],
	"219": [
		5703,
		7749,
		9597
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}